import { render, staticRenderFns } from "./ItemEditor.vue?vue&type=template&id=56fe0546&scoped=true"
import script from "./ItemEditor.vue?vue&type=script&lang=js"
export * from "./ItemEditor.vue?vue&type=script&lang=js"
import style0 from "./ItemEditor.vue?vue&type=style&index=0&id=56fe0546&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fe0546",
  null
  
)

export default component.exports